import { axiosInstance } from "../../utils/axios";
import { store } from "../../redux/store/store";
import * as uuid from "uuid";
import { TgkElaborationResponse } from "../models/tgk-elaboration-response";
import { CoObjectTypeEnum } from "../models";

/**
 * File api
 */
export interface ExcelFile {
  oid: string;
  code: string;
  desc: string;
  type: "node" | "form";
}

export interface ExcelFileInfo {
  fileName: string;
  path: string;
}

export function fetchFileExist(documentId: string, oid: string): Promise<ExcelFileInfo> {
  return (
    axiosInstance
      .get("/sharepoint/fileexist/" + documentId + "/" + oid)
      .then((resp) => resp.data) // eslint-disable-next-line no-undef
      // eslint-disable-next-line no-undef
      .catch((reason) => console.log(`Error on fetching file exist: ${reason}`))
  );
}

export function fetchFileNode(oid?: string): Promise<ExcelFile[]> {
  return (
    axiosInstance
      .get(`/sharepoint/folders` + (oid !== undefined ? `/${oid}` : ""))
      .then((resp) => resp.data) // eslint-disable-next-line no-undef
      // eslint-disable-next-line no-undef
      .catch((reason) => console.log(`Error on fetching remote data: ${reason}`))
  );
}

export function fetchSheetExcelFile(username: string, documentId: string, code: string, type: string) {
  let typeObj: CoObjectTypeEnum;
  if (type == "TABLE") {
    typeObj = CoObjectTypeEnum.TABLE_SA;
  } else if (type == "AMOUNT") {
    typeObj = CoObjectTypeEnum.AMOUNT_SA;
  } else if (type == "CHART") {
    typeObj = CoObjectTypeEnum.CHART_SA;
  }
  return fetchSheetExcelFileElab(username, documentId, code, typeObj);
}

export function fetchSheetExcelFileElab(
  username: string,
  documentId: string,
  objectId: string,
  type: CoObjectTypeEnum
): Promise<TgkElaborationResponse> {
  const clientID = store.getState().configurationState.clientId;
  const correlationID = uuid.v4();
  let elaborationRequest: SimpleElaborationRequest = {
    correlationId: correlationID,
    userId: username,
    documentId: documentId,
    clientId: clientID,
    objectId: objectId,
    objectType: type,
  };

  return axiosInstance.post(`/sharepoint/sheetandareas`, elaborationRequest).then((resp) => resp.data);
}

export interface SimpleElaborationRequest {
  correlationId: string;
  clientId: string;
  documentId: string;
  userId: string;
  objectId: string;
  objectType: CoObjectTypeEnum;
}
